<template>
  <div class="product-gallery">
    <div
      class="product-gallery__navigation"
      dir="ltr"
    >
      <div
        v-for="image in images"
        :key="image"
        class="product-gallery__navigation__item"
        :class="{ 'product-gallery__navigation__item--active': chosenImage === image }"
        @click="onChooseImage(image)"
      >
        <img :src="getFullImagePath(image)" />
      </div>
    </div>

    <div class="product-gallery__jumbotron">
      <img :src="getFullImagePath(chosenImage)" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { shallowRef, watch } from "vue"

import { getFullImagePath } from "@/utils/cdn"

type Props = {
  images: Array<string>
}

const props = defineProps<Props>()

const chosenImage = shallowRef<string>(props.images[0])

const onChooseImage = (image: string) => {
  chosenImage.value = image
}

watch(
  () => props.images,
  (images) => onChooseImage(images[0])
)
</script>

<style lang="scss" scoped>
.product-gallery {
  display: flex;
  gap: 16px;

  & img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  &__navigation {
    display: flex;
    flex-flow: column nowrap;

    height: 360px;
    overflow-y: auto;

    gap: 16px;
    padding-right: 8px;
    scroll-snap-type: y mandatory;
    scroll-margin: 0;

    &__item {
      width: 64px;
      height: 64px;
      padding: 12.5px;

      border: 1px solid #e7e7e7;
      border-radius: 4px;

      cursor: pointer;
      scroll-snap-align: end;

      &--active {
        border: 1px solid $brand-color-6;
      }
    }
  }

  &__jumbotron {
    width: calc(100% - 72px - 16px);
    height: 360px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
